import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from "react";
import { Utils } from "@react-awesome-query-builder/core";
import PropTypes from "prop-types";
import range from "lodash/range";
import { defaultValue } from "../../utils/stuff";
import { useOnPropsChanged } from "../../utils/reactUtils";
import pick from "lodash/pick";
import WidgetFactory from "./WidgetFactory";
import classNames from "classnames";
import { Col } from "../utils";
var _Utils$ConfigUtils = Utils.ConfigUtils,
  getFieldConfig = _Utils$ConfigUtils.getFieldConfig,
  getOperatorConfig = _Utils$ConfigUtils.getOperatorConfig,
  getFieldWidgetConfig = _Utils$ConfigUtils.getFieldWidgetConfig;
var _Utils$RuleUtils = Utils.RuleUtils,
  getValueSourcesForFieldOp = _Utils$RuleUtils.getValueSourcesForFieldOp,
  getWidgetForFieldOp = _Utils$RuleUtils.getWidgetForFieldOp,
  getValueLabel = _Utils$RuleUtils.getValueLabel;
var createListFromArray = Utils.DefaultUtils.createListFromArray;
var funcArgDummyOpDef = {
  cardinality: 1
};
var Widget = /*#__PURE__*/function (_Component) {
  _inherits(Widget, _Component);
  var _super = _createSuper(Widget);
  function Widget(_props) {
    var _this;
    _classCallCheck(this, Widget);
    _this = _super.call(this, _props);
    _this._setValue = function (isSpecialRange, delta, widgetType, value, asyncListValues, __isInternal) {
      if (isSpecialRange && Array.isArray(value)) {
        var oldRange = [_this.props.value.get(0), _this.props.value.get(1)];
        if (oldRange[0] != value[0]) _this.props.setValue(0, value[0], widgetType, asyncListValues, __isInternal);
        if (oldRange[1] != value[1]) _this.props.setValue(1, value[1], widgetType, asyncListValues, __isInternal);
      } else {
        _this.props.setValue(delta, value, widgetType, asyncListValues, __isInternal);
      }
    };
    _this._onChangeValueSrc = function (delta, srcKey) {
      _this.props.setValueSrc(delta, srcKey);
    };
    _this.renderWidget = function (delta, meta, props) {
      var config = props.config,
        isFuncArg = props.isFuncArg,
        leftField = props.leftField,
        operator = props.operator,
        values = props.value,
        valueError = props.valueError,
        readonly = props.readonly,
        parentField = props.parentField,
        parentFuncs = props.parentFuncs,
        id = props.id,
        groupId = props.groupId,
        fieldSrc = props.fieldSrc,
        fieldType = props.fieldType,
        isLHS = props.isLHS;
      var settings = config.settings;
      var widgets = meta.widgets,
        iValues = meta.iValues,
        aField = meta.aField,
        valueSources = meta.valueSources;
      var value = isFuncArg ? iValues : values;
      var field = isFuncArg ? leftField : aField;
      var _widgets$delta = widgets[delta],
        valueSrc = _widgets$delta.valueSrc,
        valueLabel = _widgets$delta.valueLabel;
      var hasValueSources = valueSources.length > 1 && !readonly;
      var widgetLabel = settings.showLabels ? /*#__PURE__*/React.createElement("label", {
        className: "rule--label"
      }, valueLabel.label) : null;
      return /*#__PURE__*/React.createElement("div", {
        key: "widget-" + field + "-" + delta,
        className: classNames(valueSrc == "func" ? "widget--func" : "widget--widget", hasValueSources ? "widget--has-valuerscs" : "widget--has-no-valuerscs")
      }, valueSrc == "func" ? null : widgetLabel, /*#__PURE__*/React.createElement(WidgetFactory, _extends({
        id: id,
        groupId: groupId,
        valueSrc: valueSrc,
        delta: delta,
        value: value,
        valueError: valueError,
        isFuncArg: isFuncArg,
        isLHS: isLHS
      }, pick(meta, ["isSpecialRange", "fieldDefinition", "asyncListValues"]), pick(widgets[delta], ["widget", "widgetDefinition", "widgetValueLabel", "valueLabels", "textSeparators", "setValueHandler"]), {
        config: config,
        field: field,
        fieldSrc: fieldSrc,
        fieldType: fieldType,
        parentField: parentField,
        parentFuncs: parentFuncs,
        operator: operator,
        readonly: readonly
      })));
    };
    _this.renderValueSources = function (delta, meta, props) {
      var config = props.config,
        isFuncArg = props.isFuncArg,
        leftField = props.leftField,
        operator = props.operator,
        readonly = props.readonly;
      var settings = config.settings;
      var valueSources = meta.valueSources,
        widgets = meta.widgets,
        aField = meta.aField;
      var field = isFuncArg ? leftField : aField;
      var _widgets$delta2 = widgets[delta],
        valueSrc = _widgets$delta2.valueSrc,
        setValueSrcHandler = _widgets$delta2.setValueSrcHandler;
      var valueSourcesInfo = settings.valueSourcesInfo,
        renderValueSources = settings.renderValueSources;
      var valueSourcesOptions = valueSources.map(function (srcKey) {
        return [srcKey, {
          label: valueSourcesInfo[srcKey].label
        }];
      });
      var ValueSources = function ValueSources(pr) {
        return renderValueSources(pr, config.ctx);
      };
      var sourceLabel = settings.showLabels ? /*#__PURE__*/React.createElement("label", {
        className: "rule--label"
      }, "\xA0") : null;
      return valueSources.length > 1 && !readonly && /*#__PURE__*/React.createElement("div", {
        key: "valuesrc-" + field + "-" + delta,
        className: "widget--valuesrc"
      }, sourceLabel, /*#__PURE__*/React.createElement(ValueSources, {
        key: "valuesrc-" + delta,
        delta: delta,
        valueSources: valueSourcesOptions,
        valueSrc: valueSrc,
        config: config,
        field: field,
        operator: operator,
        setValueSrc: setValueSrcHandler,
        readonly: readonly,
        title: settings.valueSourcesPopupTitle
      }));
    };
    _this.renderSep = function (delta, meta, props) {
      var config = props.config;
      var widgets = meta.widgets;
      var settings = config.settings;
      var sepText = widgets[delta].sepText;
      var sepLabel = settings.showLabels ? /*#__PURE__*/React.createElement("label", {
        className: "rule--label"
      }, "\xA0") : null;
      return sepText && /*#__PURE__*/React.createElement("div", {
        key: "widget-separators-" + delta,
        className: classNames("widget--sep", delta == 0 && "widget--sep-first")
      }, sepLabel, /*#__PURE__*/React.createElement("span", null, sepText));
    };
    _this.renderWidgetDelta = function (delta) {
      var sep = _this.renderSep(delta, _this.meta, _this.props);
      var sources = _this.renderValueSources(delta, _this.meta, _this.props);
      var widgetCmp = _this.renderWidget(delta, _this.meta, _this.props);
      return [sep, sources, widgetCmp];
    };
    useOnPropsChanged(_assertThisInitialized(_this));
    _this.onPropsChanged(_props);
    return _this;
  }
  _createClass(Widget, [{
    key: "onPropsChanged",
    value: function onPropsChanged(nextProps) {
      var prevProps = this.props;
      var keysForMeta = ["config", "field", "fieldSrc", "fieldType", "fieldFunc", "fieldArg", "leftField", "operator", "valueSrc", "isFuncArg", "asyncListValues", "isLHS"];
      var needUpdateMeta = !this.meta || keysForMeta.map(function (k) {
        return nextProps[k] !== prevProps[k]
        //tip: for isFuncArg we need to wrap value in Imm list
        || k == "isFuncArg" && nextProps["isFuncArg"] && nextProps["value"] !== prevProps["value"];
      }).filter(function (ch) {
        return ch;
      }).length > 0;
      if (needUpdateMeta) {
        this.meta = this.getMeta(nextProps);
      }
    }
  }, {
    key: "getMeta",
    value: function getMeta(_ref) {
      var _this2 = this;
      var config = _ref.config,
        simpleField = _ref.field,
        fieldSrc = _ref.fieldSrc,
        fieldType = _ref.fieldType,
        fieldFunc = _ref.fieldFunc,
        fieldArg = _ref.fieldArg,
        operator = _ref.operator,
        valueSrcs = _ref.valueSrc,
        values = _ref.value,
        isForRuleGroup = _ref.isForRuleGroup,
        isCaseValue = _ref.isCaseValue,
        isFuncArg = _ref.isFuncArg,
        leftField = _ref.leftField,
        asyncListValues = _ref.asyncListValues;
      var field = isFuncArg ? {
        func: fieldFunc,
        arg: fieldArg
      } : simpleField;
      var isOkWithoutField = !simpleField && fieldType;
      var iValueSrcs = valueSrcs;
      var iValues = values;
      if (isFuncArg || isForRuleGroup || isCaseValue) {
        iValueSrcs = createListFromArray([valueSrcs]);
        iValues = createListFromArray([values]);
      }
      var fieldDefinition = getFieldConfig(config, field);
      if (!fieldDefinition && isOkWithoutField) {
        fieldDefinition = config.types[fieldType];
      }
      var defaultWidget = getWidgetForFieldOp(config, field, operator);
      if (!defaultWidget && isOkWithoutField) {
        var _config$types$fieldTy;
        defaultWidget = (_config$types$fieldTy = config.types[fieldType]) === null || _config$types$fieldTy === void 0 ? void 0 : _config$types$fieldTy.mainWidget;
      }
      var operatorDefinition = isFuncArg ? funcArgDummyOpDef : getOperatorConfig(config, operator, field);
      if ((fieldDefinition == null || operatorDefinition == null) && !isCaseValue) {
        return null;
      }
      var isSpecialRange = operatorDefinition === null || operatorDefinition === void 0 ? void 0 : operatorDefinition.isSpecialRange;
      var isSpecialRangeForSrcField = isSpecialRange && (iValueSrcs.get(0) == "field" || iValueSrcs.get(1) == "field");
      var isTrueSpecialRange = isSpecialRange && !isSpecialRangeForSrcField;
      var cardinality = isTrueSpecialRange ? 1 : defaultValue(operatorDefinition === null || operatorDefinition === void 0 ? void 0 : operatorDefinition.cardinality, 1);
      if (cardinality === 0) {
        return null;
      }
      var valueSources = getValueSourcesForFieldOp(config, field, operator, fieldDefinition);
      if (!field) {
        valueSources = Object.keys(config.settings.valueSourcesInfo);
      }
      var widgets = range(0, cardinality).map(function (delta) {
        var _widgetDefinition;
        var valueSrc = iValueSrcs.get(delta) || null;
        var widget = getWidgetForFieldOp(config, field, operator, valueSrc);
        var widgetDefinition = getFieldWidgetConfig(config, field, operator, widget, valueSrc);
        if (isSpecialRangeForSrcField) {
          widget = widgetDefinition.singleWidget;
          widgetDefinition = getFieldWidgetConfig(config, field, operator, widget, valueSrc);
        }
        if (!widgetDefinition && isOkWithoutField) {
          widget = ["func", "field"].includes(valueSrc) ? valueSrc : defaultWidget;
          widgetDefinition = config.widgets[widget];
        }
        var widgetType = (_widgetDefinition = widgetDefinition) === null || _widgetDefinition === void 0 ? void 0 : _widgetDefinition.type;
        var valueLabel = getValueLabel(config, field, operator, delta, valueSrc, isTrueSpecialRange);
        var widgetValueLabel = getValueLabel(config, field, operator, delta, null, isTrueSpecialRange);
        var sepText = operatorDefinition !== null && operatorDefinition !== void 0 && operatorDefinition.textSeparators ? operatorDefinition === null || operatorDefinition === void 0 ? void 0 : operatorDefinition.textSeparators[delta] : null;
        var setValueSrcHandler = _this2._onChangeValueSrc.bind(_this2, delta);
        var valueLabels = null;
        var textSeparators = null;
        if (isSpecialRange) {
          valueLabels = [getValueLabel(config, field, operator, 0), getValueLabel(config, field, operator, 1)];
          valueLabels = {
            placeholder: [valueLabels[0].placeholder, valueLabels[1].placeholder],
            label: [valueLabels[0].label, valueLabels[1].label]
          };
          textSeparators = operatorDefinition === null || operatorDefinition === void 0 ? void 0 : operatorDefinition.textSeparators;
        }
        var setValueHandler = _this2._setValue.bind(_this2, isSpecialRange, delta, widgetType);
        return {
          valueSrc: valueSrc,
          valueLabel: valueLabel,
          widget: widget,
          sepText: sepText,
          setValueSrcHandler: setValueSrcHandler,
          widgetDefinition: widgetDefinition,
          widgetValueLabel: widgetValueLabel,
          valueLabels: valueLabels,
          textSeparators: textSeparators,
          setValueHandler: setValueHandler
        };
      });
      return {
        defaultWidget: defaultWidget,
        fieldDefinition: fieldDefinition,
        operatorDefinition: operatorDefinition,
        isSpecialRange: isTrueSpecialRange,
        cardinality: cardinality,
        valueSources: valueSources,
        widgets: widgets,
        iValues: iValues,
        //correct for isFuncArg
        aField: field,
        //correct for isFuncArg
        asyncListValues: asyncListValues
      };
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.meta) return null;
      var _this$meta = this.meta,
        defaultWidget = _this$meta.defaultWidget,
        cardinality = _this$meta.cardinality;
      if (!defaultWidget) return null;
      var name = defaultWidget;
      return /*#__PURE__*/React.createElement(Col, {
        className: "rule--widget rule--widget--".concat(name.toUpperCase()),
        key: "widget-col-" + name
      }, range(0, cardinality).map(this.renderWidgetDelta));
    }
  }]);
  return Widget;
}(Component);
Widget.propTypes = {
  config: PropTypes.object.isRequired,
  value: PropTypes.any,
  //instanceOf(Immutable.List)
  valueSrc: PropTypes.any,
  //instanceOf(Immutable.List)
  valueError: PropTypes.any,
  field: PropTypes.any,
  fieldSrc: PropTypes.string,
  fieldType: PropTypes.string,
  operator: PropTypes.string,
  readonly: PropTypes.bool,
  asyncListValues: PropTypes.array,
  id: PropTypes.string,
  groupId: PropTypes.string,
  //actions
  setValue: PropTypes.func,
  setValueSrc: PropTypes.func,
  // for isFuncArg
  isFuncArg: PropTypes.bool,
  fieldFunc: PropTypes.string,
  fieldArg: PropTypes.string,
  leftField: PropTypes.any,
  // for RuleGroupExt
  isForRuleGroup: PropTypes.bool,
  parentField: PropTypes.string,
  // for func in func
  parentFuncs: PropTypes.array,
  isLHS: PropTypes.bool,
  // for case_value
  isCaseValue: PropTypes.bool
};
export { Widget as default };